import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ApiRoutes, refreshTokenExceptions, tokenExceptions } from '../constans/api';
import { genToastBody, getErrorDesc } from '../helpers/helpers';
import i18n from '../i18n';
import store from '../redux/store';
import { refreshToken } from '../services/auth';

const axiosInstance = axios.create({
  baseURL: '/api',
});
let refreshIsInProgress = false;
let requestQue: any = [];

function onRefreshed(authorisationToken: any) {
  requestQue.map((cb: any) => cb(authorisationToken));
}

function subscribeTokenRefresh(cb: any) {
  requestQue.push(cb);
}
axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (config.headers) {
      const { url } = config;
      config.headers['Accept-Language'] = i18n.language;
      if (url && !tokenExceptions.includes(url)) {
        const { userData } = store.getState().auth;
        const token = userData?.access;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      }
      return config;
    }
    return config;
  },
  async err => await Promise.reject(err)
);

const interceptorOnRejected = async (config: any, response: AxiosResponse) => {
  const { url, method } = config;
  const { status, data } = response;
  const newDetails = getErrorDesc(data);
  const { title, description } = newDetails;
  const orginalRequest = config;
  const urlArr = url.split('/');
  if (refreshTokenExceptions.includes(url)) {
    return Promise.reject(response);
  }
  if (url === ApiRoutes.refreshToken) {
    await genToastBody(title, description);
    return Promise.reject(response);
  }
  if (status === 401) {
    const retryOrigReq = new Promise(resolve => {
      subscribeTokenRefresh((token: string) => {
        orginalRequest.headers.Authorization = `Bearer ${token}`;
        resolve(axios(orginalRequest));
      });
    });
    if (!refreshIsInProgress) {
      refreshIsInProgress = true;
      const refreshedAccessToken = await refreshToken();
      refreshIsInProgress = false;
      onRefreshed(refreshedAccessToken);
      requestQue = [];
    }
    return retryOrigReq;
  }
  if (
    (method === 'post' && url === ApiRoutes.surveyList) ||
    (method === 'post' && urlArr.includes('participants')) ||
    (method === 'post' && urlArr.includes('reporting-groups')) ||
    (method === 'patch' && urlArr.includes('participants'))
  ) {
    return Promise.reject(response);
  }
  if (
    ((status === 409 || status === 400) &&
      (method === 'post' || method === 'patch') &&
      url.includes(ApiRoutes.participantsTeams)) ||
    url.includes(ApiRoutes.reportingGroups)
  ) {
    return Promise.reject(response);
  }
  await genToastBody(title, description);
  return Promise.reject(response);
};

axiosInstance.interceptors.response.use(
  response => response,
  async ({ response, config }) => await interceptorOnRejected(config, response)
);

export default axiosInstance;
